export default __webpack_public_path__ + "img/bAqZhbvx.9853e901.svg";